import clsx from "clsx";

export const parentContainer = clsx(
    "w-full flex justify-center mb-20 md:mb-40",
);
export const innerContainer = clsx(
    "flex flex-col md:flex-row md:min-h-[400px] w-[90%]",
);
export const leftSide = clsx(
    "flex items-center md:items-start md:w-1/2 p-16 h-[200px] md:h-full rounded-t-lg md:rounded-tr-none md:rounded-l-lg bg-[#FF6B6B]",
);
export const rightSide = clsx(
    "md:w-1/2 p-16 rounded-b-lg md:rounded-bl-none md:rounded-r-lg bg-[#FBBFBF]",
);
export const supportText = clsx(
    "ml-4 text-2xl uppercase tracking-widest lg:text-4xl",
);
